$(document).ready(function(){
  new Swiper('.coll_swiperMain', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Navigation arrows
    navigation: {
      nextEl: '.coll_next',
      prevEl: '.coll_prev',
    },
    slidesPerView: 1,
    breakpoints: {
      480:{
        slidesPerView: 2,
        spaceBetweenSlides: 30
      },
      767: {
        slidesPerView: 3,
        spaceBetweenSlides: 30
      },
      1024: {
        slidesPerView: 3,
        spaceBetweenSlides: 40
      },
       1199:{
        slidesPerView: 4,
        spaceBetweenSlides: 40
      }
    }
  });
});



// index collection list
$(document).ready(function(){
    new Swiper('#swiper-2', {
    // Optional parameters
    direction: 'horizontal',
   
    loop: true,


    // Navigation arrows
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
    },
    slidesPerView: 1,
       breakpoints: {
         480:{
                slidesPerView: 2,
            spaceBetweenSlides: 30
         },

        767: {
            slidesPerView: 3,
            spaceBetweenSlides: 30
        },
            1024: {
            slidesPerView: 4,
            spaceBetweenSlides: 40
        },
         1199:{
                slidesPerView: 5,
            spaceBetweenSlides: 40
        }
    }

  });
});






$(document).ready(function(){$(window).innerWidth()>=1199&&($(".header__inline-menu ul.header__submenu.list-menu--disclosure").prepend('<div class="submenu--tab--wrap--main"></div>'),$(".header__submenu summary.header__menu-item").wrapAll('<div class="submenu--tab--wrap"></div>'),$(".submenu--tab--wrap--main").append($(".submenu--tab--wrap").html()),$(".header__inline-menu ul.header__submenu.list-menu--disclosure").children("li").each(function(e){$(this).attr("id","tab-"+e)}),$(".header__inline-menu ul.header__submenu.list-menu--disclosure .submenu--tab--wrap--main summary.header__menu-item").each(function(e){$(this).attr("data-tab","tab-"+e)}),$(".submenu--tab--wrap--main summary.header__menu-item").on("click",function(){var e=$(this).attr("data-tab");$(".submenu--tab--wrap--main summary.header__menu-item").removeClass("current"),$(".header__inline-menu ul.header__submenu.list-menu--disclosure").children("li").removeClass("current"),$(this).addClass("current"),$("#"+e).addClass("current")}),$(".header__inline-menu ul.header__submenu.list-menu--disclosure li details").replaceWith(function(){return $("<div/>",{class:"myClass",html:this.innerHTML})}),$(".header__inline-menu ul.header__submenu.list-menu--disclosure li .myClass .submenu--tab--wrap").hide())});





